import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getCookie } from "../../utils/utils";
import { $api } from "../../api/api";
import $axios from "../../api/accessor";

export interface UserDataType {
  id: number;
  name: string;
  surname: string;
  phone1_number: string;
  phone1_prefix: string;
  read_notification_count: number;
}

interface UserState {
  userInfo: UserDataType | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  userInfo: null,
  loading: false,
  error: null,
};

export const fetchUser = createAsyncThunk<
  UserDataType | null,
  void,
  { rejectValue: string | null }
>("user/fetchUser", async (_, { rejectWithValue }) => {
  const token = getCookie("ColibriToken");

  if (!token) {
    return;
  }
  try {
    const response = await $axios.get($api("get_myAccount"), {
      headers: {
        "Accept-Language": "az",
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data?.original;
  } catch (error: any) {
    if (error.response?.status !== 403) {
      console.error("User fetch error:", error);
    }
    return rejectWithValue(null);
  }
});

const userSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    logout: (state) => {
      state.userInfo = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchUser.fulfilled,
        (state, action: PayloadAction<UserDataType | null>) => {
          state.loading = false;
          state.userInfo = action.payload;
        },
      )
      .addCase(
        fetchUser.rejected,
        (state, action: PayloadAction<string | null | undefined>) => {
          state.loading = false;
          state.userInfo = null;
          state.error = action.payload ?? "Unknown error";
        },
      );
  },
});

export const { logout } = userSlice.actions;
export default userSlice.reducer;
